import { useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { initializeApp } from "firebase/app";
import Cookies from "js-cookie";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { BaseUrl } from "../const.ts";

const firebaseConfig = {
  apiKey: "AIzaSyA2kPohFjBi3JmKDLRIKKjplnACXxmF4lk",
  authDomain: "eventapp-8d20f.firebaseapp.com",
  projectId: "eventapp-8d20f",
  storageBucket: "eventapp-8d20f.appspot.com",
  messagingSenderId: "704868899556",
  appId: "1:704868899556:web:2cb6280f89fa7852cc2af1",
  measurementId: "G-5J5GCZ7NDD",
};

initializeApp(firebaseConfig);

export const useGoogleSignIn = () => {
  const toast = useToast();
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: "select_account" });

    try {
      const result = await signInWithPopup(auth, provider);
      const credential = GoogleAuthProvider.credentialFromResult(result);

      const res: any = await axios.get(
          `${BaseUrl}/user/login/with-google?token=${credential?.idToken}`
      );

      await Cookies.set("access", res.data.body.token);
      await Cookies.set("userId", res.data.body.userId);

      toast({
        position: "top",
        title: "Successfully logged in",
        status: "success",
        isClosable: true,
      });
      navigate(0);
    } catch (error) {
      console.error("Google Sign-In Error:", error);
    }
  };

  return { handleGoogleSignIn };
};
